import { useState } from 'react'

import { useDate } from '../../../hooks'
import { MonthDays } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { controls, date, numberSize } from '../Controls'

export function MonthDaysUsage() {
  const current = useDate(Infinity)

  const [props, setProps] = useState(() =>
    controls()
      .add(numberSize('size')) //
      .add(date('value', current))
      .add(date('today', null))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={MonthDays}
        name='MonthDays'
      />
      <ComponentProps name='MonthDays' value={props} onChange={setProps} />
    </>
  )
}
